<template>
  <div class="formily-copy">
    <span> {{ value }} </span>
    <i class="crm-Icon_copy" @click="copyClick"></i>
  </div>
</template>
<script>
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
import { copyContent } from '@/common/utils/util'
export default {
  name: 'Copy',
  components: {},
  props: {
    value: {},
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    copyClick() {
      copyContent(this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.formily-copy {
  display: flex;
  align-items: center;
  padding: 16px 0;
  span {
    font-family: DiDiSans-Pro-Medium;
    font-size: 28px;
    color: #282b33;
    line-height: 36px;
    font-weight: 500;
  }
  .crm-Icon_copy {
    font-size: 28px;
    color: #111111;
    margin-left: 9.5px;
  }
}
</style>
